var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResearchCost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#BDEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.737 18.6902L18.7644 17.7177C19.0637 17.2688 19.2133 16.7451 19.2133 16.2215C19.2133 14.5756 17.8667 13.2291 16.2209 13.2291C14.5751 13.2291 13.2285 14.5756 13.2285 16.2215C13.2285 17.8673 14.5751 19.2138 16.2209 19.2138C16.7446 19.2138 17.2682 19.0642 17.7171 18.765L18.6896 19.7375C18.8392 19.8871 19.2881 20.1864 19.737 19.7375C20.0362 19.4383 20.0362 18.9894 19.737 18.6902ZM16.2209 17.7177C15.398 17.7177 14.7247 17.0444 14.7247 16.2215C14.7247 15.3985 15.398 14.7253 16.2209 14.7253C17.0438 14.7253 17.7171 15.3985 17.7171 16.2215C17.7171 17.0444 17.0438 17.7177 16.2209 17.7177Z",
    fill: "#60CCFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2215 5H5.7481C5.29924 5 5 5.29924 5 5.7481V19.2139C5 19.6627 5.29924 19.962 5.7481 19.962H13.7527C12.5558 19.139 11.7329 17.7925 11.7329 16.2215C11.7329 13.7527 13.7527 11.7329 16.2215 11.7329C16.4459 11.7329 16.7451 11.7329 16.9696 11.8077V5.7481C16.9696 5.29924 16.6703 5 16.2215 5ZM10.9848 10.9848H7.24429C6.79543 10.9848 6.4962 10.6107 6.4962 10.2367C6.4962 9.78783 6.79543 9.48859 7.24429 9.48859H10.9848C11.4336 9.48859 11.7329 9.78783 11.7329 10.2367C11.7329 10.6107 11.4336 10.9848 10.9848 10.9848ZM14.7253 7.99239H7.24429C6.79543 7.99239 6.4962 7.61834 6.4962 7.24429C6.4962 6.79543 6.79543 6.4962 7.24429 6.4962H14.7253C15.1741 6.4962 15.4734 6.79543 15.4734 7.24429C15.4734 7.61834 15.1741 7.99239 14.7253 7.99239Z",
    fill: "#60CCFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchCost);
export default __webpack_public_path__ + "static/media/research-cost.7c44ce30.svg";
export { ForwardRef as ReactComponent };